import React, { useState, useEffect } from "react";
import {
    DialogTitle,
    DialogActions,
    IconButton,
    DialogContent,
    Grid,
    Tooltip,
    Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import { TextView } from "@components";
import ReuseableButton from "../../WheelGallery/Button";
import CustomSwitch from "../../CustomSwitch";
import { colors } from "../../../utils";
import {
    StyledDialog,
    StyledRadio,
    Divider,
    ToolTipStyled
} from "./styles";
import SearchField from "../../WheelGallery/WheelListing/ListComponents/SearchField";

const CreateFolderModal = ({
    isVisible,
    onClose,
    onCreateButtonPress,
    onCancelButtonPress,
    isLoading,
    editMode = false,
    folderData = null,
}) => {
    const [folderTitle, setFolderTitle] = useState("");
    const [exclude, setExclude] = useState(false);
    const [status, setStatus] = useState({
        everyone: true,
        onlyMe: false,
    });

    useEffect(() => {
        if (!isVisible) {
            resetForm();
        }
    }, [isVisible]);

    useEffect(() => {
        if (editMode && folderData) {
            setFolderTitle(folderData.name || "");
            setExclude(folderData.gallery_visibility || false);
            setStatus({
                everyone: folderData.visibility === 1,
                onlyMe: folderData.visibility === 2,
            });
        }
    }, [editMode, folderData]);

    const resetForm = () => {
        setFolderTitle("");
        setExclude(false);
        setStatus({
            everyone: true,
            onlyMe: false,
        });
    };

    const handleCheck = (type) => {
        setStatus((prev) => ({
            everyone: type === "everyone",
            onlyMe: type === "onlyMe",
        }));
    };

    return (
        <>
            <StyledDialog open={isVisible} onClose={onClose}>
                <DialogTitle>
                    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                        <Stack direction={'row'} alignItems={'center'} spacing={1}>
                            <CreateNewFolderIcon style={{ fontSize: 30, color: "black" }} />
                            <TextView variant="title">{editMode ? 'Update Folder' : 'Create Folder'}</TextView>
                        </Stack>
                        <IconButton aria-label="close" onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <TextView variant="subtitle" style={{ color: "black", padding: "15px 0" }}>
                        Add Title
                    </TextView>
                    <SearchField
                        height={48}
                        placeholder="Folder Title"
                        isHideIcon={true}
                        value={folderTitle}
                        onChange={(val) => setFolderTitle(val)}
                    />

                    <div style={{ display: "flex", marginTop: 10 }}>
                        <CustomSwitch
                            checked={exclude}
                            onChange={() => setExclude(!exclude)}
                            inputProps={{ "aria-label": "controlled" }}
                        />
                        <TextView variant="text" style={{ marginTop: 7 }}>
                            Hide Contents from Gallery
                        </TextView>
                        <Tooltip title="Toggling on will prevent the Folder’s contents from displaying in the ‘Wheels’ tab on the Gallery">
                            <ToolTipStyled>i</ToolTipStyled>
                        </Tooltip>
                    </div>

                    <TextView variant="subtitle" style={{ color: "black", padding: "15px 0" }}>
                        Visibility to:
                    </TextView>
                    <Grid container spacing={2}>
                        <Grid item xs={10.25}><TextView variant="text">Everyone</TextView></Grid>
                        <Grid item xs={1}><StyledRadio checked={status.everyone} onClick={() => handleCheck("everyone")} /></Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={10.25}><TextView variant="text">Only me</TextView></Grid>
                        <Grid item xs={1}><StyledRadio checked={status.onlyMe} onClick={() => handleCheck("onlyMe")} /></Grid>
                    </Grid>
                    <Divider />
                    <DialogActions>
                        <ReuseableButton onClick={onCancelButtonPress} text="Cancel" variant="text" textColor="black" customStyles={{ padding: "4px 20px" }} />
                        <ReuseableButton 
                            text={editMode ? "Update" : "Create"} 
                            customStyles={{ backgroundColor: colors.PrimaryPurple, padding: "4px 20px" }} 
                            onClick={() => onCreateButtonPress(folderTitle, status, exclude)} 
                        />
                    </DialogActions>
                </DialogContent>
            </StyledDialog>
        </>
    );
};

export default CreateFolderModal;
